import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberToCurrency } from '../../../services/utils';
import './Summary.sass';
import {
  shippingPriceSelector, itemTotalSelector, promotionsSelector,
  taxesSelector, orderTotalSelector, amountForFreeShippingSelector,
  appliedStoreCreditSelector,
} from '../../../selectors/order';
import { shipmentsSelector } from '../../../selectors/shipping';

function Summary(props) {
  const {
    shippingPrice, itemTotal, orderTotal, promotions, taxes,
    showCongratulations, estimatedTotal, amountForFreeShipping,
    appliedStoreCredit, shipments,
  } = props;

  return (
    <div className="summary">
      { showCongratulations && shipments.length > 0 && shippingPrice === 0 && (
        <div className="congratulations">
          Congrats! You get
          {' '}
          <b>FREE shipping</b>
        </div>
      )}
      {
        showCongratulations && amountForFreeShipping > 0
          && (
            <div className="congratulations">
              {`Add $${amountForFreeShipping} for `}
              <b>FREE shipping</b>
            </div>
          )
      }
      <div className="subtotal">
        <div className="element">
          <div className="title">
            Subtotal
          </div>
          <div className="price">
            {itemTotal}
          </div>
        </div>
        { shipments.length > 0 && (
          <div className="element green">
            <div className="title">
              Shipping
            </div>
            <div className="price">
              {numberToCurrency(shippingPrice)}
            </div>
          </div>
        )}
        { promotions && promotions.map((promotion) => (
          <div key={promotion.id} className="element green">
            <div className="title">
              {promotion.label}
            </div>
            <div className="price">
              {promotion.price}
            </div>
          </div>
        ))}
        { taxes && taxes.map((tax) => (
          <div key={tax.id} className="element gray">
            <div className="title">
              {tax.label}
            </div>
            <div className="price">
              {tax.price}
            </div>
          </div>
        ))}
      </div>
      <div className="element total">
        <div className="title">
          { estimatedTotal ? 'Estimated Total' : 'Total' }
        </div>
        <div className="price">
          {numberToCurrency(orderTotal + shippingPrice)}
        </div>
      </div>
      { appliedStoreCredit > 0 && (
        <div className="element total">
          <div className="title">
            Store Credit
          </div>
          <div className="price">
            -
            {numberToCurrency(appliedStoreCredit)}
          </div>
        </div>
      )}
    </div>
  );
}

Summary.propTypes = {
  estimatedTotal: PropTypes.bool,
  itemTotal: PropTypes.string.isRequired,
  orderTotal: PropTypes.number.isRequired,
  promotions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shippingPrice: PropTypes.number.isRequired,
  showCongratulations: PropTypes.bool,
  taxes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  amountForFreeShipping: PropTypes.number.isRequired,
  appliedStoreCredit: PropTypes.number.isRequired,
  shipments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Summary.defaultProps = {
  estimatedTotal: false,
  showCongratulations: false,
};

const mapStateToProps = (state) => ({
  shippingPrice: shippingPriceSelector(state),
  itemTotal: itemTotalSelector(state),
  promotions: promotionsSelector(state),
  taxes: taxesSelector(state),
  orderTotal: orderTotalSelector(state),
  amountForFreeShipping: amountForFreeShippingSelector(state),
  appliedStoreCredit: appliedStoreCreditSelector(state),
  shipments: shipmentsSelector(state),
});

export default connect(mapStateToProps)(Summary);
